import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Cada mes sin sistema financiero claro',
    cost: 'Deudas que crecen con intereses mientras esperás'
  }, {
    without: 'Estrés financiero crónico sin herramientas',
    cost: 'Impacto en salud, relaciones y rendimiento laboral'
  }, {
    without: 'Sin canal de ingreso adicional',
    cost: 'Un solo ingreso = máxima vulnerabilidad económica'
  }, {
    without: 'Sin reprogramación de creencias',
    cost: 'Los mismos patrones de escasez se repiten año tras año'
  }, {
    without: 'Sin red de valor activa',
    cost: 'Oportunidades que pasan y no ves'
  }, {
    without: 'Domingo con angustia financiera',
    cost: 'El mismo ciclo el próximo año y el siguiente'
  }];
  return <Section data-id="element-49">
      <div className="text-center mb-12" data-id="element-50">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-51">
          <span className="mr-3" data-id="element-52">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-53">
        {/* Desktop: 2-column grid */}
        <div className="hidden md:block" data-id="element-54">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-55">
            <div className="font-serif font-bold text-lg text-brand-text/80" data-id="element-56">
              Sin MegaPack
            </div>
            <div className="font-serif font-bold text-lg text-red-500" data-id="element-57">
              Costo Real
            </div>
          </div>
          <div className="space-y-3" data-id="element-58">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-red-200 bg-white/60" data-id="element-59">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-60">
                  {row.without}
                </div>
                <div className="text-sm text-red-600/90 font-medium" data-id="element-61">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile: stacked cards */}
        <div className="md:hidden space-y-4" data-id="element-62">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl space-y-2 border-red-200 pt-[10px] pb-[10px] pl-[10px] pr-[10px] bg-white/60" data-id="element-63">
              <p className="text-sm font-medium text-brand-text/90" data-id="element-64">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-red-600/90 font-medium" data-id="element-65">
                <span className="text-red-500 shrink-0" data-id="element-66">→</span>
                <span className="text-sm" data-id="element-67">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-68">
        <h3 className="md:text-3xl font-serif font-bold gold-gradient-text mb-6 text-[20px]" data-id="element-69">
          "El próximo domingo puede ser diferente."
        </h3>
        <p className="italic text-brand-text/80 text-[16px]" data-id="element-70">
          "La abundancia no es lo que tenés. Es lo que sos cuando no tenés
          miedo."
        </p>
        <p className="text-brand-text/60 mt-4 font-medium" data-id="element-71">✦ Lumen Akasha ✦</p>
      </div>
    </Section>;
};